import axios from 'axios';
import {baseURL, dataScienceURL, otherBaseURL} from '../config';
import {transformData} from '../WhatIfAnalysis/helper';

export const DEMOGRAPHIC_LABELS = {
  Age: ['Under 5 years', '5 to 9 years', '10 to 14 years', '15 to 19 years', '20 to 24 years', '25 to 34 years', '35 to 44 years', '45 to 54 years', '55 to 59 years', '60 to 64 years', '65 to 74 years', '75 to 84 years', '85 years and over'],
  Education: [
    'Less than 9th grade',
    '9th to 12th grade, no diploma',
    'High school graduate',
    'High school graduate or higher',
    "Associate's degree",
    "Bachelor's degree",
    "Bachelor's degree or higher",
    "Graduate or professional degree",
    'Some college, no degree'
  ],
  Income: ['Less than $10,000', '$10,000 to $14,999', '$15,000 to $24,999', '$25,000 to $34,999', '$35,000 to $49,999', '$50,000 to $74,999', '$75,000 to $99,999', '$100,000 to $149,999', '$150,000 to $199,999', '$200,000 or more'],
  Race: ['American Indian and Alaska Native', 'Asian Indian', 'Asian Chinese', 'Black or African American', 'Native Hawaiian and Other Pacific Islander', 'Other Asian', 'Some other race', 'Two or more races', 'White'],
  Industry: [
    'Finance and insurance, and real estate and rental and leasing',
    'Information',
    'Professional, scientific, and management, and administrative and waste management services',
    'Wholesale trade',
    'Retail trade',
    'Educational services, and health care and social assistance',
    'Manufacturing',
    'Public administration',
    'Other services, except public administration',
    'Arts, entertainment, and recreation, and accommodation and food services',
    'Construction',
    'Transportation and warehousing, and utilities',
    'Agriculture, forestry, fishing and hunting, and mining'
  ],
  'Transportation': [
    'Walked',
    'Worked from home',
    'Car, truck, or van -- drove alone',
    'Car, truck, or van -- carpooled',
    'Public transportation (excluding taxicab)',
    'Other means'
  ]
}

export const PROPERTY_TYPE_LABELS = ['Condo/Co-op', 'Multi-Family (2-4 Unit)', 'Single Family Residential', 'Townhouse']

export const getAnticipatedPredictionData = async (
  query: string,
  data: any,
  type: string
) => {
  let resp = {
    chart_data: {
      actual_predictions: {
        "2023-10-01": 167,
        "2023-11-01": 171,
        "2023-12-01": 186,
        "2024-01-01": 192,
        "2024-02-01": 198,
        "2024-03-01": 204,
        "2024-04-01": 208,
        "2024-05-01": 210,
        "2024-06-01": 212,
        "2024-07-01": 213,
        "2024-08-01": 214,
        "2024-09-01": 213,
        "2024-10-01": 212,
        "2024-11-01": 210,
        "2024-12-01": 200,
        "2025-01-01": 203,
        "2025-02-01": 202,
        "2025-03-01": 202,
        "2025-04-01": 202,
        "2025-05-01": 201,
        "2025-06-01": 200,
        "2025-07-01": 199,
        "2025-08-01": 204,
        "2025-09-01": 209,
        "2025-10-01": 215,
        "2025-11-01": 221,
        "2025-12-01": 227,
        "2026-01-01": 233,
        "2026-02-01": 234,
        "2026-03-01": 236,
        "2026-04-01": 238,
        "2026-05-01": 236,
        "2026-06-01": 234,
        "2026-07-01": 233,
        "2026-08-01": 231,
        "2026-09-01": 229,
        "2026-10-01": 227,
        "2026-11-01": 226,
        "2026-12-01": 225,
        "2027-01-01": 224,
        "2027-02-01": 227,
        "2027-03-01": 230,
        "2027-04-01": 233,
        "2027-05-01": 238,
        "2027-06-01": 243,
        "2027-07-01": 249,
        "2027-08-01": 247,
        "2027-09-01": 245,
        "2027-10-01": 244,
        "2027-11-01": 240,
        "2027-12-01": 237,
        "2028-01-01": 234,
        "2028-02-01": 233,
        "2028-03-01": 232,
        "2028-04-01": 232,
        "2028-05-01": 232,
        "2028-06-01": 232,
        "2028-07-01": 232,
        "2028-08-01": 231,
        "2028-09-01": 230,
        "2028-10-01": 229,
      },
      adjusted_prediction: {
        "2023-10-01": 167.0,
        "2023-11-01": 171.0,
        "2023-12-01": 186.0,
        "2024-01-01": 192.0,
        "2024-02-01": 198.0,
        "2024-03-01": 204.0,
        "2024-04-01": 208.0,
        "2024-05-01": 210.0,
        "2024-06-01": 212.0,
        "2024-07-01": 213.0,
        "2024-08-01": 214.0,
        "2024-09-01": 213.0,
        "2024-10-01": 212.0,
        "2024-11-01": 210.0,
        "2024-12-01": 200.0,
        "2025-01-01": 203.0,
        "2025-02-01": 202.0,
        "2025-03-01": 202.0,
        "2025-04-01": 202.0,
        "2025-05-01": 201.0,
        "2025-06-01": 200.0,
        "2025-07-01": 199.0,
        "2025-08-01": 204.0,
        "2025-09-01": 209.0,
        "2025-10-01": 215.0,
        "2025-11-01": 221.0,
        "2025-12-01": 227.0,
        "2026-01-01": 233.0,
        "2026-02-01": 234.0,
        "2026-03-01": 236.0,
        "2026-04-01": 238.0,
        "2026-05-01": 236.0,
        "2026-06-01": 234.0,
        "2026-07-01": 233.0,
        "2026-08-01": 231.0,
        "2026-09-01": 229.0,
        "2026-10-01": 227.0,
        "2026-11-01": 226.0,
        "2026-12-01": 225.0,
        "2027-01-01": 224.0,
        "2027-02-01": 227.0,
        "2027-03-01": 230.0,
        "2027-04-01": 233.0,
        "2027-05-01": 238.0,
        "2027-06-01": 243.0,
        "2027-07-01": 249.0,
        "2027-08-01": 247.0,
        "2027-09-01": 245.0,
        "2027-10-01": 244.0,
        "2027-11-01": 240.0,
        "2027-12-01": 237.0,
        "2028-01-01": 234.0,
        "2028-02-01": 233.0,
        "2028-03-01": 232.0,
        "2028-04-01": 232.0,
        "2028-05-01": 232.0,
        "2028-06-01": 232.0,
        "2028-07-01": 232.0,
        "2028-08-01": 231.0,
        "2028-09-01": 230.0,
        "2028-10-01": 229.0,
      },
    },
  };
  try {
    const response = await axios.post(
      `${otherBaseURL}nationGrowthImpact/${query}/${type}`,
      data
    );
    resp = response.data;
  } catch (e) {
    console.error(e);
  }
  return transformData(resp?.chart_data);
};

export const getCountyByState = async (state: string) => {
  let preSelectionInfo: any = [];
  let countyInfo: any = [];
  const response = await axios.get(`${baseURL}getCountyByState?state=${state}`);
  if (response.data?.cube?.length) {
    countyInfo = response.data?.cube?.map((item: any) => {
      return {
        name: item.county,
      };
    });
    // countyInfo.sort((a: any, b: any) => {
    //   return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
    // });
  }
  return {
    data: countyInfo,
  };
};

export const getStateZipCodesData = async (state: any, months: string, radius: string) => {
  let query = '';
  if (state) query = `?state=${state}`;

  query += `&flag=${months}_months&radius_type=${radius}`

  const response = await axios.get(`${baseURL}heatMapData${query}`);
  const profitableExpectedData = []
  const profitablePpsfGrowthData = []
  const profitableHomeSalesData = []
  const profitableDaysOnMarketData = []
  const data = response.data?.cube;
  const totalCount = data.length;
  for (let i in data) {
    const info = data[i]
    if (parseInt(info.dom_flag) === 1) profitableDaysOnMarketData.push(info)
    if (parseInt(info.ppsf_growth_flag) === 1) profitablePpsfGrowthData.push(info)
    if (parseInt(info.hs_flag) === 1) profitableHomeSalesData.push(info)
    if (parseInt(info.expected_returns_flag) === 1) profitableExpectedData.push(info)
  }

  return {
    data,
    profitableExpectedData,
    profitablePpsfGrowthData,
    profitableHomeSalesData,
    profitableDaysOnMarketData,
    totalCount,
  }
};

export const markerData = (stateData: any[]) => {
  const markersInfo = []
  for (let i = 0; i < stateData.length; i++) {
    const data = stateData[i]
    let distanceFromFactoryCentre1 = data.distance_from_factory_centre1
    let distanceFromFactoryCentre2 = data.distance_from_factory_centre2
    let distanceFromFactoryCentre3 = data.distance_from_factory_centre3
    if (distanceFromFactoryCentre1.toString() !== '0') distanceFromFactoryCentre1 = (Math.round(distanceFromFactoryCentre1 * 100) / 100).toFixed(2)
    if (distanceFromFactoryCentre2.toString() !== '0') distanceFromFactoryCentre2 = (Math.round(distanceFromFactoryCentre2 * 100) / 100).toFixed(2)
    if (distanceFromFactoryCentre3.toString() !== '0') distanceFromFactoryCentre3 = (Math.round(distanceFromFactoryCentre3 * 100) / 100).toFixed(2)
    const properties = {
      factoryCentre1: data.factory_centre1,
      factoryCentre2: data.factory_centre2,
      factoryCentre3: data.factory_centre3,
      distanceFromFactoryCentre1,
      distanceFromFactoryCentre2,
      distanceFromFactoryCentre3,
      ppsf: data.ppsf,
      expectedPpsfMean: data.expected_ppsf_mean,
      ppsfGrowthMean: (Math.round(data.ppsf_Growth_mean * 100) / 100).toFixed(2),
      medianSalePricePerHouse: data.median_sale_price_per_house,
      homeSaleCumulativeMean: data.home_sales_cumulative_mean,
      daysOnMarketMean: data.days_on_market_mean,
      highExpectedResults: (Math.round(data.high_expected_returns * 100) / 100).toFixed(2),
      state: data.state,
      zip: data.zcta5ce20,
      homeSalesMean: data.home_sales_mean,
      distanceFromProfitableZipcode: data.distance_from_profitable_zipcode,
      domGrowth: (Math.round(data.dom_growth_months * 100) / 100).toFixed(2),
      hsGrowth: (Math.round(data.hs_growth_months * 100) / 100).toFixed(2)
    }

    let isMarker = false
    let className = 'red'
    let title = 'Distance From '
    if (parseInt(data.distance_from_factory_centre1) === 0) {
      isMarker = true
      title += `Red Factory Centre: ${parseInt(data.distance_from_factory_centre1).toString()}`
      className = 'red'
    } else if (parseInt(data.distance_from_factory_centre2) === 0) {
      isMarker = true
      title += `Red Factory Centre: ${parseInt(data.distance_from_factory_centre2).toString()}`
      className = 'blue'
    } else if (parseInt(data.distance_from_factory_centre3) === 0) {
      isMarker = true
      title += `Red Factory Centre: ${parseInt(data.distance_from_factory_centre3).toString()}`
      className = 'green'
    }
    if (isMarker) {
      markersInfo.push({
        properties,
        className,
        cluster: parseInt(data.cluster) + 1,
        position: {lat: parseFloat(data.latitude), lng: parseFloat(data.longitude)},
        title
      })
    }
  }
  return markersInfo;
}

export const getGeoLocationData = async (data: any, isNested: boolean = true) => {
  let zipcodes  = []
  if (isNested) {
    zipcodes = data.map((c: { zcta5ce20: any }) => c.zcta5ce20);
  } else {
    zipcodes = data
  }

  // @ts-ignore
  const uniqueZipcodes = [...new Set(zipcodes)];
  let info = {};
  if (uniqueZipcodes.length) {
    let zip: any[] = [];
    const wholeZipSet = [];
    uniqueZipcodes.forEach((u, i) => {
      let counter = i + 1;
      if (counter % 200 === 0) {
        zip.push(u);
        wholeZipSet.push(zip);
        zip = [];
      } else {
        zip.push(u);
      }
    });
    if (zip.length) wholeZipSet.push(zip);
    let zipCodeData: any[] = [];
    for (const z of wholeZipSet) {
      const options = {
        method: 'GET',
        url: 'https://vanitysoft-boundaries-io-v1.p.rapidapi.com/rest/v1/public/boundary/zipcode',
        params: {zipcode: z.join(',')},
        headers: {
          'X-RapidAPI-Key': '9c6da7e12bmsh4e8650bef60634ep1f93b7jsna43e74547623',
          'X-RapidAPI-Host': 'vanitysoft-boundaries-io-v1.p.rapidapi.com',
        },
      };
      try {
        // @ts-ignore
        const response = await axios.request(options);
        zipCodeData = [...zipCodeData, ...response.data.features];
      } catch (e) {
        console.error(e);
      }
    }
    zipCodeData.forEach((zd) => {
      // @ts-ignore
      info[zd.properties.zipCode] = zd;
    });
    return info;
  }
};

const generateMonthRange = (start: any, end: any) => {
  const startDate = new Date(start + '-01');
  const endDate = new Date(end + '-01');
  const months = [];

  let currentDate = startDate;

  while (currentDate <= endDate) {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const formattedDate = `${year}-${month}`;

    months.push(formattedDate);

    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  return months;
}

const generateQuarterRange = (start: any, end: any) => {
  const startYear = Number(start.split('-')[0]);
  const startQuarter = Number(start.split('-')[1].slice(1));
  const endYear = Number(end.split('-')[0]);
  const endQuarter = Number(end.split('-')[1].slice(1));

  const quarters = [];

  for (let year = startYear; year <= endYear; year++) {
    const startQ = (year === startYear) ? startQuarter : 1;
    const endQ = (year === endYear) ? endQuarter : 4;

    for (let quarter = startQ; quarter <= endQ; quarter++) {
      const formattedQuarter = `${year}-Q${quarter}`;
      quarters.push(formattedQuarter);
    }
  }

  return quarters;
}

export const generateDropDownRanges = async () => {
  const start = '2023-04'
  const end = '2028-04'
  const startQuarter = '2023-Q2'
  const endQuarter = '2028-Q2'
  const cityPredValues = generateMonthRange(start, end)
  const zipcodePredValues = generateQuarterRange(startQuarter, endQuarter)
  const currentDate = new Date()
  const year = currentDate.getFullYear()
  const month = currentDate.getMonth() - 1
  const date = new Date(year, month, 1)
  let predictionTill = {
    tennessee: {
      city: date,
      zip: date,
      cityPredValues: cityPredValues,
      zipcodePredValues: zipcodePredValues
    },
    california: {
      city: date,
      zip: date,
      cityPredValues: cityPredValues,
      zipcodePredValues: zipcodePredValues
    },
    florida: {
      city: date,
      zip: date,
      cityPredValues: cityPredValues,
      zipcodePredValues: zipcodePredValues
    },
    texas: {
      city: date,
      zip: date,
      cityPredValues: cityPredValues,
      zipcodePredValues: zipcodePredValues
    }
  }

  try {
    const response = await axios.get(`${baseURL}getdetails`);
    const data = response?.data || null
    if (data) {
      for (let i in data) {
        const state = data[i].state.toLowerCase()
        const cityDate = data[i].cityPredDate.split('-').map((s: any) => parseInt(s))
        const zipDate = data[i].zipcodePredDate.split('-').map((z: any) => parseInt(z))
        // @ts-ignore
        predictionTill[state] = {
          city: new Date(cityDate[0], cityDate[1] - 1, cityDate[2]),
          zip: new Date(zipDate[0], zipDate[1] - 1, zipDate[2]),
          cityPredValues: data[i].cityPredValues,
          zipcodePredValues: data[i].zipcodePredValues
        }
      }
    }
  } catch (e) {
    console.error(e)
  }
  return predictionTill
}

export const getQuarterFromDate = (dateString: string) => {
  const date = new Date(dateString);
  const month = date.getMonth();

  if (month >= 0 && month <= 2) {
    return date.getFullYear() + '-Q1';
  } else if (month >= 3 && month <= 5) {
    return date.getFullYear() + '-Q2';
  } else if (month >= 6 && month <= 8) {
    return date.getFullYear() + '-Q3';
  } else {
    return date.getFullYear() + '-Q4';
  }
}

export const getTopCities = async (state: string) => {
  try {
    const response = await axios.get(`${dataScienceURL}getTopCitiesByState?state=${state}&freq=1_year`);
    return response.data?.cube.map((c: any) => c.city);
  } catch (e) {
    console.error(e)
    return []
  }
}

export const getMetroZipcode = async (state: string, metro: string) => {
  const metroZipcodes = []
  try {
    const zipcodeResponse = await axios.get(`${baseURL}getCitiesByMetro?state=${state}&metroarea=${metro}`);
    if (zipcodeResponse.data && zipcodeResponse.data.cities && zipcodeResponse.data.cities.length) {
      const zipcodes = zipcodeResponse.data.cities.map((z: any) => z.zipcodes.split(' '))
      metroZipcodes.push(zipcodes)
    }
  } catch (e) {
    console.log(e)
  }
  return metroZipcodes
}

export const getMetroGeoLocationData = async (zipcodes: any) => {
  let zipCodeData: any[] = [];
  if (zipcodes.length) {
    let info = {};
    // @ts-ignore
    const uniqueZipcodes = [...new Set(zipcodes)];
    if (uniqueZipcodes.length) {
      const options = {
        method: 'GET',
        url: 'https://vanitysoft-boundaries-io-v1.p.rapidapi.com/rest/v1/public/boundary/zipcode',
        params: {zipcode: uniqueZipcodes.join(',')},
        headers: {
          'X-RapidAPI-Key': '9c6da7e12bmsh4e8650bef60634ep1f93b7jsna43e74547623',
          'X-RapidAPI-Host': 'vanitysoft-boundaries-io-v1.p.rapidapi.com',
        },
      };
      try {
        // @ts-ignore
        const response = await axios.request(options);
        zipCodeData = response.data.features
      } catch (e) {
        console.error(e)
      }
    }
  }
  return zipCodeData
};

const findPolygonCenter = (coordinates: any) => {
  const numPoints = coordinates[0].length;
  const totalLat = coordinates[0].reduce((acc: any, coord: any) => acc + coord[1], 0);
  const totalLon = coordinates[0].reduce((acc: any, coord: any) => acc + coord[0], 0);
  const centerLat = totalLat / numPoints;
  const centerLon = totalLon / numPoints;
  return {centerLat, centerLon};
}

export const getGeoJSONCenter = (data: any) => {
  let totalFeatures = 0;
  let totalLat = 0;
  let totalLon = 0;

  for (const feature of data) {
    // @ts-ignore
    const featureCoordinates = feature?.geometry?.coordinates;
    const {centerLat, centerLon} = findPolygonCenter(featureCoordinates);

    if (!isNaN(centerLat) && !isNaN(centerLon)) {
      totalFeatures++;
      totalLat += centerLat;
      totalLon += centerLon;
    }
  }

  const averageLat = totalLat / totalFeatures;
  const averageLon = totalLon / totalFeatures;

  return {centerLat: averageLat, centerLon: averageLon};
}

export const getMetroByState = async (state: string) => {
  let citiesInfo: any = []
  const response = await axios.get(`${baseURL}getMetroCitiesByState?state=${state}`);
  if (response.data && response.data.cube && response.data.cube.length) {
    citiesInfo = response.data.cube.map((r: any) => ({
      name: r.city,
      type: r.type,
      alias: r.city_alias,
      symbol: r.type === 'Metro' ? 'MSA' : 'μSA'
    }));
  }
  return {
    data: citiesInfo,
    selection: []
  }
}

export const getCityByState = async (state: string) => {
  let preSelectionInfo: any = []
  let citiesInfo: any = []
  const response = await axios.get(`${baseURL}getCityByState?state=${state}`)
  if (response.data?.cube?.length) {
    citiesInfo = response.data?.cube?.map((item: any) => {
      return {
        name: item.city,
        zipcodes: item.zipcodes,
      };
    });
    citiesInfo.sort((a: any, b: any) => {
      return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
    });

    const tempZipcodes = citiesInfo.filter((t: any) => t?.zipcodes !== '')
    preSelectionInfo = tempZipcodes.length ? tempZipcodes.map((t: any) => t.zipcodes.split(',').map((z: string) => `${z}_${t.name}`)) : [[]]
  }
  return {
    data: citiesInfo,
    selection: preSelectionInfo
  }
}

export const generateChartData = (input: any, type: string, isPercentage: boolean = false) => {
  const TYPE_NOT_IN = ['population', 'mean_travel_time']
  const cities = Object.keys(input).sort();
  let counter = 1
  const emptyObjectIndex = []
  const cityInfo: any = []
  for (const city of cities) {
    let baseDate: any = ''
    input[city].forEach((cityData: any, index: any) => {
      const seriesDate = TYPE_NOT_IN.includes(type) ? `${cityData.year}-01-01` : cityData.date
      const entryIndex = cityInfo.findIndex(info => info.date === seriesDate)
      let isNew = false
      let entry = {}
      if (entryIndex === -1) {
        isNew = true
        entry = {date: seriesDate}
      } else {
        entry = cityInfo[entryIndex]
      }

      if (index === 0 && !TYPE_NOT_IN.includes(type)) baseDate = subtractOneMonth(cityData.date)
      // @ts-ignore
      entry[`value${counter}`] = cityData[type] || 0
      if (counter > 1 && emptyObjectIndex.length) {
        emptyObjectIndex.forEach(objectIndex => {
          entry[`value${objectIndex}`] =  0
        })
      }
      if (isPercentage) {
        // @ts-ignore
        entry[`value${counter}_absolute`] = cityData[type]
        // @ts-ignore
        entry[`value${counter}_base_date`] = baseDate
        // @ts-ignore
        entry[`value${counter}_base_value`] = cityData.base_val
        // @ts-ignore
        entry[`value${counter}_base_per`] = cityData.pct_change || calculatePercentage(cityData.base_val, cityData[type])

        let lastYearInfo = getLastYearDateFromData(cityData, input, city, type)
        if (!lastYearInfo) {
          lastYearInfo = {
            per: '-',
            value: '-',
            date: 'No Data Available'
          }
        }
        // @ts-ignore
        entry[`value${counter}_last_year_per`] = lastYearInfo.per
        // @ts-ignore
        entry[`value${counter}_last_year_value`] = lastYearInfo.value
        // @ts-ignore
        entry[`value${counter}_last_year_date`] = lastYearInfo.date
      }
      if (isNew) cityInfo.push(entry)
    })
    if (input[city].length === 0) emptyObjectIndex.push(counter)
    counter++
  }
  return sortByDate(cityInfo);
}
export const mergeChartData = (results:any,msa:any) => {
  // Create a map to store data by date
  const dataMap = new Map();
  
  
  // Process each result set
  results.forEach((result:any, index:any) => {
    const { category, data } = result;
    
    data.forEach((item:any) => {
      const dateKey = item.date;
      
      if (!dataMap.has(dateKey)) {
        // Initialize the entry if it doesn't exist
        dataMap.set(dateKey, { date: dateKey });
      }
      
      const entry = dataMap.get(dateKey);
      
      // Add the value with appropriate naming based on category and MSA
      msa.forEach((msa:any, msaIndex:any) => {
        if (item[`value${msaIndex+1}`] !== undefined) {
          entry[`${category}_${msa.name}`] = item[`value${msaIndex+1}`];
        }
      });
    });
  });
  
  // Convert map back to array
  return Array.from(dataMap.values());
};

const parseDifferentFormatDate = (dateString: string) => {
  const mmddyyyyRegex = /^\d{2}\/\d{2}\/\d{4}$/;
  const yyyy_mm_ddRegex = /^\d{4}-\d{2}-\d{2}$/;
  const dd_mm_yyyyRegex = /^\d{2}-\d{2}-\d{4}$/;

  if (mmddyyyyRegex.test(dateString)) {
    const parts = dateString.split('/');
    const mm = parseInt(parts[0], 10);
    const dd = parseInt(parts[1], 10);
    const yyyy = parseInt(parts[2], 10);
    return new Date(yyyy, mm - 1, dd);
  } else if (yyyy_mm_ddRegex.test(dateString)) {
    return new Date(dateString);
  } else if (dd_mm_yyyyRegex.test(dateString)) {
    const parts = dateString.split('-');
    const dd = parseInt(parts[0], 10);
    const mm = parseInt(parts[1], 10);
    const yyyy = parseInt(parts[2], 10);
    return new Date(yyyy, mm - 1, dd);
  } else {
    throw new Error('Invalid date format');
  }
}

const formatDate = (data: any) => {
  const result: any[] = []
  data.forEach((i: any) => {
    const providedDate = i.date;
    delete i.date
    i.date = parseDifferentFormatDate(providedDate).toLocaleString('default', {month: 'short', year: 'numeric'})
    result.push(i)
  })
  return result
}

const transformObject = (inputObject: any) => {
  const entries = Object.entries(inputObject).map(([key, value]) => [key, Object.keys(value).length]);
  entries.sort((a, b) => b[1] - a[1]);
  const transformedObject = {};
  for (let i = 0; i < entries.length; i++) {
    transformedObject[entries[i][0]] = inputObject[entries[i][0]];
  }

  return transformedObject;
}

export const generateBarChartData = (inputObj: any) => {
  const input = transformObject(inputObj)
  const output = [];

  // Extract the dates from the first age group
  const dates = Object.keys(input[Object.keys(input)[0]]);

  // Iterate over each date
  for (const date of dates) {
    const newObj = {date};

    // Iterate over each age group
    for (const ageGroup in input) {
      // @ts-ignore
      newObj[ageGroup] = isNaN(parseInt(input[ageGroup][date])) ? 0 : parseInt(input[ageGroup][date]);
    }

    output.push(newObj);
  }
  return formatDate(output);
}

const getLastYearDateFromData = (currentData: any, allData: any, city: any, type: any) => {
  const lastYearDate = getLastYearDate(currentData.date)
  const info = allData[city]
  const lastYearData = info.find((i: any) => i.date === lastYearDate)
  if (lastYearData) {
    return {
      per: calculatePercentage(lastYearData[type], currentData[type]),
      value: lastYearData[type],
      date: lastYearData.date
    }
  }
  return null
}

export const calculatePercentage = (baseValue: any, currentValue: any) => {
  if (baseValue === 0) {
    return currentValue >= 0 ? Infinity : -Infinity;
  }

  const percentageChange = ((currentValue - baseValue) / baseValue) * 100;
  return percentageChange.toFixed(2)

}

const subtractOneMonth = (dateString: string) => {
  const date = new Date(dateString);
  date.setMonth(date.getMonth() - 1);
  return date.toISOString().split('T')[0];
}

const getLastYearDate = (dateString: string) => {
  const date = new Date(dateString);
  date.setFullYear(date.getFullYear() - 1);
  return date.toISOString().split('T')[0];
}

export const predictionTableHeaders = (type: string) => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  if (type === "cityPredictions") {
    return [
      { name: "City", interval: false, key: "city" },
      { name: "PPSF (low)", interval: true, key: "ppsfLow" },
      { name: "PPSF", interval: false, key: "ppsf" },
      { name: "PPSF (high)", interval: true, key: "ppsfHigh" },
      { name: "PPSF Growth % (low)", interval: true, key: "ppsfLowGrowth" },
      {
        name: "Median PPSF Growth (%)",
        interval: false,
        key: "ppsfMeanGrowth",
      },
      { name: "PPSF Growth % (high)", interval: true, key: "ppsfHighGrowth" },
      { name: "MSP (low)", interval: true, key: "mspLow" },
      { name: "MSP ($)", interval: false, key: "msp" },
      { name: "MSP (high)", interval: true, key: "mspHigh" },
      { name: "MSP Growth % (low)", interval: true, key: "mspLowGrowth" },
      { name: "MSP Growth (%)", interval: false, key: "mspMeanGrowth" },
      { name: "MSP Growth % (high)", interval: true, key: "mspHighGrowth" },
      { name: "DOM (low)", interval: true, key: "domLow" },
      { name: "Median DOM", interval: false, key: "domMean" },
      { name: "DOM (high)", interval: true, key: "domHigh" },
      { name: "HS (low)", interval: true, key: "homeSalesLow" },
      { name: "HS", interval: false, key: "homeSalesMean" },
      { name: "HS (high)", interval: true, key: "homeSalesHigh" },
      { name: "HSC (low)", interval: true, key: "home_sales_cumulative_low" },
      {
        name: "Median HSC",
        interval: false,
        key: "home_sales_cumulative_mean",
      },
      { name: "HSC (high)", interval: true, key: "home_sales_cumulative_high" },
      {
        name: `Population ${year - 1} `,
        interval: false,
        key: "population_2021",
      },
      {
        name: "population_Growth_1_year",
        interval: false,
        key: "population_Growth_1_year",
      },
      {
        name: "population_growth_3_year",
        interval: false,
        key: "population_growth_3_year",
      },
      {
        name: "population_growth_5_year",
        interval: false,
        key: "population_growth_5_year",
      },
    ];
  } else if (type === "countyPredictions") {
    return [
      { name: "County", interval: false, key: "county" },
      { name: "PPSF (low)", interval: true, key: "ppsfLow" },
      { name: "PPSF", interval: false, key: "ppsf" },
      { name: "PPSF (high)", interval: true, key: "ppsfHigh" },
      { name: "PPSF Growth % (low)", interval: true, key: "ppsfLowGrowth" },
      {
        name: "Median PPSF Growth (%)",
        interval: false,
        key: "ppsfMeanGrowth",
      },
      { name: "PPSF Growth % (high)", interval: true, key: "ppsfHighGrowth" },
      { name: "MSP (low)", interval: true, key: "mspLow" },
      { name: "MSP ($)", interval: false, key: "msp" },
      { name: "MSP (high)", interval: true, key: "mspHigh" },
      { name: "MSP Growth % (low)", interval: true, key: "mspLowGrowth" },
      { name: "MSP Growth (%)", interval: false, key: "mspMeanGrowth" },
      { name: "MSP Growth % (high)", interval: true, key: "mspHighGrowth" },
      { name: "DOM (low)", interval: true, key: "domLow" },
      { name: "Median DOM", interval: false, key: "domMean" },
      { name: "DOM (high)", interval: true, key: "domHigh" },
      { name: "HS (low)", interval: true, key: "homeSalesLow" },
      { name: "HS", interval: false, key: "homeSalesMean" },
      { name: "HS (high)", interval: true, key: "homeSalesHigh" },
      { name: "HSC (low)", interval: true, key: "home_sales_cumulative_low" },
      {
        name: "Median HSC",
        interval: false,
        key: "home_sales_cumulative_mean",
      },
      { name: "HSC (high)", interval: true, key: "home_sales_cumulative_high" },
    
    ];
  } else if (type === "zipcodePredictions") {
    return [
      { name: "Zip Code", interval: false, key: "zipCode" },
      { name: "PPSF (low)", interval: true, key: "ppsfLow" },
      { name: "PPSF", interval: false, key: "ppsf" },
      { name: "PPSF (high)", interval: true, key: "ppsfHigh" },
      { name: "PPSF Growth % (low)", interval: true, key: "ppsfLowGrowth" },
      {
        name: "Median PPSF Growth (%)",
        interval: false,
        key: "ppsfMeanGrowth",
      },
      { name: "PPSF Growth % (high)", interval: true, key: "ppsfHighGrowth" },
      { name: "MSP (low)", interval: true, key: "mspLow" },
      { name: "MSP ($)", interval: false, key: "msp" },
      { name: "MSP (high)", interval: true, key: "mspHigh" },
      { name: "MSP Growth % (low)", interval: true, key: "mspLowGrowth" },
      { name: "MSP Growth (%)", interval: false, key: "mspMeanGrowth" },
      { name: "MSP Growth % (high)", interval: true, key: "mspHighGrowth" },
      { name: "DOM (low)", interval: true, key: "domLow" },
      { name: "Median DOM", interval: false, key: "domMean" },
      { name: "DOM (high)", interval: true, key: "domHigh" },
      { name: "HS (low)", interval: true, key: "homeSalesLow" },
      { name: "HS", interval: false, key: "homeSalesMean" },
      { name: "HS (high)", interval: true, key: "homeSalesHigh" },
      { name: "HSC (low)", interval: true, key: "hscLow" },
      { name: "Median HSC", interval: false, key: "hscMean" },
      { name: "HSC (high)", interval: true, key: "hscHigh" },
    ];
  } else if (type === "msaPredictions") {
    return [
      { name: "Metro Area", interval: false, key: "metroarea" },
      { name: "PPSF (low)", interval: true, key: "ppsfLow" },
      { name: "PPSF", interval: false, key: "ppsf" },
      { name: "PPSF (high)", interval: true, key: "ppsfHigh" },
      { name: "PPSF Growth % (low)", interval: true, key: "ppsfLowGrowth" },
      {
        name: "Median PPSF Growth (%)",
        interval: false,
        key: "ppsfMeanGrowth",
      },
      { name: "PPSF Growth % (high)", interval: true, key: "ppsfHighGrowth" },
      { name: "MSP (low)", interval: true, key: "mspLow" },
      { name: "MSP ($)", interval: false, key: "msp" },
      { name: "MSP (high)", interval: true, key: "mspHigh" },
      { name: "MSP Growth % (low)", interval: true, key: "mspLowGrowth" },
      { name: "MSP Growth (%)", interval: false, key: "mspMeanGrowth" },
      { name: "MSP Growth % (high)", interval: true, key: "mspHighGrowth" },
      { name: "DOM (low)", interval: true, key: "domLow" },
      { name: "Median DOM", interval: false, key: "domMean" },
      { name: "DOM (high)", interval: true, key: "domHigh" },
      { name: "DOM Growth % (low)", interval: true, key: "domLowGrowth" },
      { name: "DOM Growth (%)", interval: false, key: "domMeanGrowth" },
      { name: "DOM Growth % (high)", interval: true, key: "domHighGrowth" },
      { name: "HS (low)", interval: true, key: "homeSalesLow" },
      { name: "HS", interval: false, key: "homeSalesMean" },
      { name: "HS (high)", interval: true, key: "homeSalesHigh" },
      { name: "HSC (low)", interval: true, key: "home_sales_cumulative_low" },
      {
        name: "Median HSC",
        interval: false,
        key: "home_sales_cumulative_mean",
      },
      { name: "HSC (high)", interval: true, key: "home_sales_cumulative_high" },
    ];
  }
};

export const excelData = (headers: any, json: any) => {
  const data: any = []
  json.forEach((j: any) => {
    let info = {}
    headers.forEach((h: any) => {
      // @ts-ignore
      info[h.name] = j[h.key]
    })
    data.push(info)
  })

  return data
}

export const capitalizeFirstLetter = (sentence: string) => {
  const words = sentence.split(' ');
  const capitalizedWords = words.map(word => {
    if (word.length > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }
    return word;
  });
  return capitalizedWords.join(' ');
}

const sortByDate = (data: any) => {
  data.sort((a: any, b: any) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);

    // Compare the dates
    if (dateA < dateB) {
      return -1;
    } else if (dateA > dateB) {
      return 1;
    } else {
      return 0;
    }
  });

  return data;
}

const mergeObjectsByKey = (objects: any) => {
  const mergedData = {};
  const mergeValues = (target: any, source: any) => {
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        target[key] = source[key];
      }
    }
  }

  for (const obj of objects) {
    for (const item of obj) {
      const keyValue = item.date;
      // @ts-ignore
      if (!mergedData[keyValue]) {
        // @ts-ignore
        mergedData[keyValue] = {};
      }
      // @ts-ignore
      mergeValues(mergedData[keyValue], item);
    }
  }

  const result = [];
  for (const key in mergedData) {
    if (mergedData.hasOwnProperty(key)) {
      // @ts-ignore
      const mergedItem = {['date']: key, ...mergedData[key]};
      result.push(mergedItem);
    }
  }

  return result;
}

export const getAdjustedPredictionData = async (query: string, data: any, type: string) => {
  let resp = {
    chart_data: {
      actual_predictions: {
        "2023-10-01": 167,
        "2023-11-01": 171,
        "2023-12-01": 186,
        "2024-01-01": 192,
        "2024-02-01": 198,
        "2024-03-01": 204,
        "2024-04-01": 208,
        "2024-05-01": 210,
        "2024-06-01": 212,
        "2024-07-01": 213,
        "2024-08-01": 214,
        "2024-09-01": 213,
        "2024-10-01": 212,
        "2024-11-01": 210,
        "2024-12-01": 200,
        "2025-01-01": 203,
        "2025-02-01": 202,
        "2025-03-01": 202,
        "2025-04-01": 202,
        "2025-05-01": 201,
        "2025-06-01": 200,
        "2025-07-01": 199,
        "2025-08-01": 204,
        "2025-09-01": 209,
        "2025-10-01": 215,
        "2025-11-01": 221,
        "2025-12-01": 227,
        "2026-01-01": 233,
        "2026-02-01": 234,
        "2026-03-01": 236,
        "2026-04-01": 238,
        "2026-05-01": 236,
        "2026-06-01": 234,
        "2026-07-01": 233,
        "2026-08-01": 231,
        "2026-09-01": 229,
        "2026-10-01": 227,
        "2026-11-01": 226,
        "2026-12-01": 225,
        "2027-01-01": 224,
        "2027-02-01": 227,
        "2027-03-01": 230,
        "2027-04-01": 233,
        "2027-05-01": 238,
        "2027-06-01": 243,
        "2027-07-01": 249,
        "2027-08-01": 247,
        "2027-09-01": 245,
        "2027-10-01": 244,
        "2027-11-01": 240,
        "2027-12-01": 237,
        "2028-01-01": 234,
        "2028-02-01": 233,
        "2028-03-01": 232,
        "2028-04-01": 232,
        "2028-05-01": 232,
        "2028-06-01": 232,
        "2028-07-01": 232,
        "2028-08-01": 231,
        "2028-09-01": 230,
        "2028-10-01": 229
      },
      adjusted_prediction: {
        "2023-10-01": 167.0,
        "2023-11-01": 171.0,
        "2023-12-01": 186.0,
        "2024-01-01": 192.0,
        "2024-02-01": 198.0,
        "2024-03-01": 204.0,
        "2024-04-01": 208.0,
        "2024-05-01": 210.0,
        "2024-06-01": 212.0,
        "2024-07-01": 213.0,
        "2024-08-01": 214.0,
        "2024-09-01": 213.0,
        "2024-10-01": 212.0,
        "2024-11-01": 210.0,
        "2024-12-01": 200.0,
        "2025-01-01": 203.0,
        "2025-02-01": 202.0,
        "2025-03-01": 202.0,
        "2025-04-01": 202.0,
        "2025-05-01": 201.0,
        "2025-06-01": 200.0,
        "2025-07-01": 199.0,
        "2025-08-01": 204.0,
        "2025-09-01": 209.0,
        "2025-10-01": 215.0,
        "2025-11-01": 221.0,
        "2025-12-01": 227.0,
        "2026-01-01": 233.0,
        "2026-02-01": 234.0,
        "2026-03-01": 236.0,
        "2026-04-01": 238.0,
        "2026-05-01": 236.0,
        "2026-06-01": 234.0,
        "2026-07-01": 233.0,
        "2026-08-01": 231.0,
        "2026-09-01": 229.0,
        "2026-10-01": 227.0,
        "2026-11-01": 226.0,
        "2026-12-01": 225.0,
        "2027-01-01": 224.0,
        "2027-02-01": 227.0,
        "2027-03-01": 230.0,
        "2027-04-01": 233.0,
        "2027-05-01": 238.0,
        "2027-06-01": 243.0,
        "2027-07-01": 249.0,
        "2027-08-01": 247.0,
        "2027-09-01": 245.0,
        "2027-10-01": 244.0,
        "2027-11-01": 240.0,
        "2027-12-01": 237.0,
        "2028-01-01": 234.0,
        "2028-02-01": 233.0,
        "2028-03-01": 232.0,
        "2028-04-01": 232.0,
        "2028-05-01": 232.0,
        "2028-06-01": 232.0,
        "2028-07-01": 232.0,
        "2028-08-01": 231.0,
        "2028-09-01": 230.0,
        "2028-10-01": 229.0
      }
    },
  }
  try {
    const response = await axios.post(`${otherBaseURL}whatIfMortegageImpact/${query}/${type}`, data);
    resp = response.data
  } catch (e) {
    console.error(e)
  }
  return transformData(resp?.chart_data)
}

export const getAdjustedSentimentData = async (query: string, data: any, type: string) => {
  let resp = {
    chart_data: {
      actual_predictions: {
        "2023-10-01": 167,
        "2023-11-01": 171,
        "2023-12-01": 186,
        "2024-01-01": 192,
        "2024-02-01": 198,
        "2024-03-01": 204,
        "2024-04-01": 208,
        "2024-05-01": 210,
        "2024-06-01": 212,
        "2024-07-01": 213,
        "2024-08-01": 214,
        "2024-09-01": 213,
        "2024-10-01": 212,
        "2024-11-01": 210,
        "2024-12-01": 200,
        "2025-01-01": 203,
        "2025-02-01": 202,
        "2025-03-01": 202,
        "2025-04-01": 202,
        "2025-05-01": 201,
        "2025-06-01": 200,
        "2025-07-01": 199,
        "2025-08-01": 204,
        "2025-09-01": 209,
        "2025-10-01": 215,
        "2025-11-01": 221,
        "2025-12-01": 227,
        "2026-01-01": 233,
        "2026-02-01": 234,
        "2026-03-01": 236,
        "2026-04-01": 238,
        "2026-05-01": 236,
        "2026-06-01": 234,
        "2026-07-01": 233,
        "2026-08-01": 231,
        "2026-09-01": 229,
        "2026-10-01": 227,
        "2026-11-01": 226,
        "2026-12-01": 225,
        "2027-01-01": 224,
        "2027-02-01": 227,
        "2027-03-01": 230,
        "2027-04-01": 233,
        "2027-05-01": 238,
        "2027-06-01": 243,
        "2027-07-01": 249,
        "2027-08-01": 247,
        "2027-09-01": 245,
        "2027-10-01": 244,
        "2027-11-01": 240,
        "2027-12-01": 237,
        "2028-01-01": 234,
        "2028-02-01": 233,
        "2028-03-01": 232,
        "2028-04-01": 232,
        "2028-05-01": 232,
        "2028-06-01": 232,
        "2028-07-01": 232,
        "2028-08-01": 231,
        "2028-09-01": 230,
        "2028-10-01": 229
      },
      adjusted_prediction: {
        "2023-10-01": 167.0,
        "2023-11-01": 171.0,
        "2023-12-01": 186.0,
        "2024-01-01": 192.0,
        "2024-02-01": 198.0,
        "2024-03-01": 204.0,
        "2024-04-01": 208.0,
        "2024-05-01": 210.0,
        "2024-06-01": 212.0,
        "2024-07-01": 213.0,
        "2024-08-01": 214.0,
        "2024-09-01": 213.0,
        "2024-10-01": 212.0,
        "2024-11-01": 210.0,
        "2024-12-01": 200.0,
        "2025-01-01": 203.0,
        "2025-02-01": 202.0,
        "2025-03-01": 202.0,
        "2025-04-01": 202.0,
        "2025-05-01": 201.0,
        "2025-06-01": 200.0,
        "2025-07-01": 199.0,
        "2025-08-01": 204.0,
        "2025-09-01": 209.0,
        "2025-10-01": 215.0,
        "2025-11-01": 221.0,
        "2025-12-01": 227.0,
        "2026-01-01": 233.0,
        "2026-02-01": 234.0,
        "2026-03-01": 236.0,
        "2026-04-01": 238.0,
        "2026-05-01": 236.0,
        "2026-06-01": 234.0,
        "2026-07-01": 233.0,
        "2026-08-01": 231.0,
        "2026-09-01": 229.0,
        "2026-10-01": 227.0,
        "2026-11-01": 226.0,
        "2026-12-01": 225.0,
        "2027-01-01": 224.0,
        "2027-02-01": 227.0,
        "2027-03-01": 230.0,
        "2027-04-01": 233.0,
        "2027-05-01": 238.0,
        "2027-06-01": 243.0,
        "2027-07-01": 249.0,
        "2027-08-01": 247.0,
        "2027-09-01": 245.0,
        "2027-10-01": 244.0,
        "2027-11-01": 240.0,
        "2027-12-01": 237.0,
        "2028-01-01": 234.0,
        "2028-02-01": 233.0,
        "2028-03-01": 232.0,
        "2028-04-01": 232.0,
        "2028-05-01": 232.0,
        "2028-06-01": 232.0,
        "2028-07-01": 232.0,
        "2028-08-01": 231.0,
        "2028-09-01": 230.0,
        "2028-10-01": 229.0
      }
    },
  }
  try {
    const response = await axios.post(`${otherBaseURL}whatIfSentimentImpact/${query}/${type}`, data);
    console.log(response)
    resp = response.data
  } catch (e) {
    console.error(e)
  }
  return transformData(resp?.chart_data)
}


export const a11yProps = (index: number) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
